export default "__VITE_ASSET__BANCXxRF__"